module.exports = __webpack_public_path__ + "media/images/main_logo-11f3fba9.png";